import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import { clearWaitlistActionSuccessMessage, selectAllEnrollmentsRosterData, selectWaitlist } from '../../../../reducers/programDashboardReducer'

import GolfersTable from './GolfersTable'
import WaitlistTable from './waitlist/WaitlistTable'
import SubmitButton from '../../../common/buttons/SubmitButton'
import SuccessModal from '../../../common/customModal/SuccessModal'

import { ReactComponent as InfoCircleIcon } from '../../../../assets/images/common/icons/info-circle-icon-outline.svg'
import { ReactComponent as GolferHalfIcon } from '../../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as CirclePlusIcon } from '../../../../assets/images/common/icons/circle-plus-icon.svg'
import { ReactComponent as FlagIcon } from '../../../../assets/images/common/icons/Flag.svg'

import classes from './EnrollmentsTab.module.scss'


const RosterTab = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { onOpenAddStudentsModal, withAddStudentsAction, handleOpenWaitlistStudentsModal } = useOutletContext()

  const { program } = useSelector(state => state.programDashboard)
  const enrollments = useSelector(selectAllEnrollmentsRosterData)
  const waitlist = useSelector(selectWaitlist)
  const waitlistActionSuccessMessage = useSelector(state => state.programDashboard.waitlistActionSuccessMessage)

  return (
    <div className={classnames('d-flex row no-gutters', classes.rosterTab)}>
      <div className={classnames('d-flex flex-column', classes.enrollments, { 'col-xl-9': program.hasWaitlistEnabled })}>
        <div className={classnames('pl-4 py-3 d-flex align-items-center', classes.header)}>
          <span className={classes.userCount}>
            {program.golferLimit
              ? t('programs.manage.rosterTab.golferCountLimit', { count: program.golferLimit, current: enrollments.length })
              : t('programs.manage.rosterTab.golferCount', { count: enrollments.length })}
          </span>
          <InfoCircleIcon role='button' className={classnames('ml-2', classes.icon)} />
        </div>
        {enrollments.length === 0 ? (
          <div className={classnames('d-flex flex-column align-items-center mx-auto', classes.placeholder)}>
            <GolferHalfIcon className={classnames('mb-2', classes.icon)} />
            <h2 className={classes.title}>{t('programs.manage.rosterTab.noEnrollmentsYet')}</h2>
            {withAddStudentsAction ? (
              <SubmitButton
                buttonMessage={t('programs.common.addStudents')}
                onClick={onOpenAddStudentsModal}
              />
            ) : (
              <p className={classes.text}>{t('programs.manage.rosterTab.shareWithCommunity')}</p>
            )}
          </div>
        ) : (
          <GolfersTable program={program} enrollments={enrollments} />
        )}
      </div>
      {program.hasWaitlistEnabled && (
        <div className={classnames('d-flex p-4 flex-column col-lg-auto col-xl', classes.waitlist)}>
          <div className={classnames(classes.waitlistHeader)}>
            <h6 className='mb-0'>{t('programs.manage.rosterTab.waitlistHeading', { count: waitlist.length })}</h6>
            <button className={classes.addButton} onClick={handleOpenWaitlistStudentsModal}>
              <CirclePlusIcon />
            </button>
          </div>
          <SuccessModal
            isOpen={!!waitlistActionSuccessMessage}
            onClose={() => dispatch(clearWaitlistActionSuccessMessage())}
            title={waitlistActionSuccessMessage?.title}
            message={waitlistActionSuccessMessage?.message}
            buttonMessage={t('common.close')}
          />
          {waitlist.length === 0 ? (
            <div className={classnames('d-flex flex-column align-items-center text-center mx-auto', classes.waitlistPlaceholder)}>
              <FlagIcon className={classnames('mb-3', classes.waitlistEmptyIcon)} width={50} height={50} />
              <h5 className={classes.message}>{t('programs.manage.rosterTab.noStudentsYet')}</h5>
              <p className={classes.waitlistPlaceholderText}>
                {t('programs.manage.rosterTab.waitlistPlaceholderText')}
              </p>
            </div>
          ) : (
            <WaitlistTable course={program} />
          )}
        </div>
      )}
    </div>
  )
}

export default RosterTab
